import React, { useState } from 'react';
import ImageWrapper from '../common/ImageWrapper';
import { IoIosArrowDown } from 'react-icons/io';
import PrimaryButton from '../common/PrimaryButton';
import AniLink from 'gatsby-plugin-transition-link/AniLink';

const Header = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const sidebarToggle = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <>
            <header id="desktop_header">
                <div className="header_first_div">
                    <AniLink fade to="/">
                        <ImageWrapper
                            ImgUrl={
                                'https://s3.us-east-2.wasabisys.com/ufaber-lms/files/ca7a73c17fbed4d81e139537e743a2fe.svg'
                            }
                            MaxWidth={239}
                        />
                    </AniLink>
                </div>
                <div className="header_second_div">
                    <nav>
                        <ul className="header_nav_wrapper">
                            <li>
                                <div className="header_nav_heading_wrapper">
                                    <span className="header_nav_heading">
                                        Programs
                                    </span>
                                    <IoIosArrowDown className="header_nav_arrow" />
                                </div>
                                <div className="header_nav_select">
                                    <ul>
                                        <AniLink
                                            fade
                                            to="/programs?programtype=ielts_general"
                                        >
                                            <li>IELTS General</li>
                                        </AniLink>
                                        <AniLink
                                            fade
                                            to="/programs?programtype=ielts_academic"
                                        >
                                            <li>IELTS Academic</li>
                                        </AniLink>
                                        <AniLink
                                            fade
                                            to="/programs?programtype=pte_academic"
                                        >
                                            <li>PTE</li>
                                        </AniLink>
                                        <AniLink
                                            fade
                                            to="/programs?programtype=oet"
                                        >
                                            <li>OET</li>
                                        </AniLink>
                                        <AniLink
                                            fade
                                            to="/programs?programtype=toefl"
                                        >
                                            <li>TOEFL</li>
                                        </AniLink>
                                        <AniLink
                                            fade
                                            to="/programs?programtype=gre"
                                        >
                                            <li>GRE</li>
                                        </AniLink>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <div className="header_nav_heading_wrapper">
                                    <span className="header_nav_heading">
                                        Resources
                                    </span>
                                    <IoIosArrowDown className="header_nav_arrow" />
                                </div>
                                <div className="header_nav_select">
                                    <ul>
                                        <AniLink fade to="/band-predictor">
                                            <li>IELTS Band Predictor</li>
                                        </AniLink>

                                        <AniLink fade to="/oet-score-predictor">
                                            <li> OET Score Predictor</li>
                                        </AniLink>
                                        <AniLink fade to="/pte-score-predictor">
                                            <li> PTE Score Predictor</li>
                                        </AniLink>
                                        <AniLink fade to="/ielts-mock-test">
                                            <li>IELTS Mock Test</li>
                                        </AniLink>

                                        <AniLink fade to="/oet-mock-test">
                                            <li> OET Mock Test</li>
                                        </AniLink>
                                        <AniLink fade to="/pte-mock-test">
                                            <li> PTE Mock Test</li>
                                        </AniLink>

                                        <a href="https://app.ieltsninja.com/masterclasses/">
                                            <li>Masterclasses</li>
                                        </a>
                                        <a href="https://ieltsninja.com/content/">
                                            <li>Exam Tips</li>
                                        </a>
                                        <AniLink fade to="/videos">
                                            <li>Video Resources</li>
                                        </AniLink>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <div className="header_nav_heading_wrapper">
                                    <span className="header_nav_heading">
                                        Results
                                    </span>
                                    <IoIosArrowDown className="header_nav_arrow" />
                                </div>
                                <div className="header_nav_select">
                                    <ul>
                                        <AniLink fade to="/results">
                                            <li>Score Cards</li>
                                        </AniLink>
                                        <AniLink fade to="/success-stories">
                                            <li>Success Stories</li>
                                        </AniLink>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <div className="header_nav_heading_wrapper">
                                    <span className="header_nav_heading">
                                        Pathways
                                    </span>
                                    <IoIosArrowDown className="header_nav_arrow" />
                                </div>
                                <div className="header_nav_select">
                                    <ul>
                                        <a href="https://abroadninja.in/study-abroad/">
                                            <li>Study Abroad</li>
                                        </a>
                                        <a href="https://abroadninja.in/settle-abroad/">
                                            <li>Permanent Residency</li>
                                        </a>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </nav>
                    <a href="https://app.ieltsninja.com/app-login/?utm_source=ielts_website_signup&utm_campaign=ielts_website&utm_medium=ielts_website">
                        <PrimaryButton
                            ButtonText={'Sign In'}
                            MaxWidth={12.5}
                            MaxHeight={3.75}
                            BorderRadius={0.625}
                        />
                    </a>
                </div>
            </header>

            <header id="mobile_header">
                <div className="mobile_header_first">
                    <div className="header_first_mobile_div">
                        <div
                            className="header_hamburger"
                            onClick={sidebarToggle}
                        >
                            <input class="hamburger_checkbox" type="checkbox" />
                            <div class="hamburger_lines">
                                <span class="line line1"></span>
                                <span class="line line2"></span>
                                <span class="line line3"></span>
                            </div>
                        </div>
                        <ImageWrapper
                            ImgUrl={
                                'https://s3.us-east-2.wasabisys.com/ufaber-lms/files/ca7a73c17fbed4d81e139537e743a2fe.svg'
                            }
                            MaxWidth={99}
                        />
                    </div>
                    <div className="header_second_mobile_div">
                        <a href="https://app.ieltsninja.com/app-login/?utm_source=ielts_website_signup&utm_campaign=ielts_website&utm_medium=ielts_website">
                            <PrimaryButton
                                ButtonText={'Sign In'}
                                MaxWidth={6.75}
                                MinWidth={6.75}
                                MaxHeight={2.25}
                                BorderRadius={0.625}
                            />
                        </a>
                    </div>
                </div>
                {sidebarOpen && (
                    <aside className="mobile_sidebar">
                        <nav>
                            <ul className="mobile_sidebar_nav_wrapper">
                                <li>
                                    <div className="mobile_sidebar_nav_heading_wrapper">
                                        <span className="mobile_sidebar_heading">
                                            Programs
                                        </span>
                                        <IoIosArrowDown className="mobile_sidebar_nav_arrow" />
                                    </div>
                                    <div className="mobile_sidebar_nav_select">
                                        <ul>
                                            <AniLink
                                                fade
                                                to="/programs?programtype=ielts_general"
                                            >
                                                <li>IELTS General</li>
                                            </AniLink>
                                            <AniLink
                                                fade
                                                to="/programs?programtype=ielts_academic"
                                            >
                                                <li>IELTS Academic</li>
                                            </AniLink>
                                            <AniLink
                                                fade
                                                to="/programs?programtype=pte_academic"
                                            >
                                                <li>PTE</li>
                                            </AniLink>
                                            <AniLink
                                                fade
                                                to="/programs?programtype=oet"
                                            >
                                                <li>OET</li>
                                            </AniLink>
                                            <AniLink
                                                fade
                                                to="/programs?programtype=toefl"
                                            >
                                                <li>TOEFL</li>
                                            </AniLink>
                                            <AniLink
                                                fade
                                                to="/programs?programtype=gre"
                                            >
                                                <li>GRE</li>
                                            </AniLink>
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    <div className="mobile_sidebar_nav_heading_wrapper">
                                        <span className="mobile_sidebar_heading">
                                            Resources
                                        </span>
                                        <IoIosArrowDown className="mobile_sidebar_nav_arrow" />
                                    </div>
                                    <div className="mobile_sidebar_nav_select">
                                        <ul>
                                            <AniLink fade to="/band-predictor">
                                                <li>IELTS Band Predictor</li>
                                            </AniLink>

                                            <AniLink
                                                fade
                                                to="/oet-score-predictor"
                                            >
                                                <li> OET Score Predictor</li>
                                            </AniLink>
                                            <AniLink
                                                fade
                                                to="/pte-score-predictor"
                                            >
                                                <li> PTE Score Predictor</li>
                                            </AniLink>
                                            <AniLink fade to="/ielts-mock-test">
                                                <li>IELTS Mock Test</li>
                                            </AniLink>

                                            <AniLink fade to="/oet-mock-test">
                                                <li> OET Mock Test</li>
                                            </AniLink>

                                            <AniLink fade to="/pte-mock-test">
                                                <li> PTE Mock Test</li>
                                            </AniLink>

                                            <a href="https://app.ieltsninja.com/masterclasses/">
                                                <li>Masterclasses</li>
                                            </a>
                                            <a href="https://ieltsninja.com/content/">
                                                <li>Exam Tips</li>
                                            </a>
                                            <AniLink fade to="/videos">
                                                <li>Video Resources</li>
                                            </AniLink>
                                        </ul>

                                        {/* <ul>
                                            <AniLink
                                                fade
                                                to="/oet-score-predictor"
                                            >
                                                <li> OET Score Predictor</li>
                                            </AniLink>
                                            <AniLink fade to="/band-predictor">
                                                <li>Band Predictor Test</li>
                                            </AniLink>
                                            <AniLink fade to="/ielts-mock-test">
                                                <li>Mock Test</li>
                                            </AniLink>
                                            <a href="https://app.ieltsninja.com/masterclasses/">
                                                <li>Masterclasses</li>
                                            </a>
                                            <a href="https://ieltsninja.com/content/">
                                                <li>Blog</li>
                                            </a>
                                            <AniLink fade to="/videos">
                                                <li>Sample Videos</li>
                                            </AniLink>
                                        </ul> */}
                                    </div>
                                </li>
                                <li>
                                    <div className="mobile_sidebar_nav_heading_wrapper">
                                        <span className="mobile_sidebar_heading">
                                            Results
                                        </span>
                                        <IoIosArrowDown className="mobile_sidebar_nav_arrow" />
                                    </div>
                                    <div className="mobile_sidebar_nav_select">
                                        <ul>
                                            <AniLink fade to="/results">
                                                <li>Score Cards</li>
                                            </AniLink>
                                            <AniLink fade to="/success-stories">
                                                <li>Success Stories</li>
                                            </AniLink>
                                        </ul>
                                    </div>
                                </li>
                                <li>
                                    <div className="mobile_sidebar_nav_heading_wrapper">
                                        <span className="mobile_sidebar_heading">
                                            Pathways
                                        </span>
                                        <IoIosArrowDown className="mobile_sidebar_nav_arrow" />
                                    </div>
                                    <div className="mobile_sidebar_nav_select">
                                        <ul>
                                            <a href="https://abroadninja.in/study-abroad/">
                                                <li>Study Abroad</li>
                                            </a>
                                            <a href="https://abroadninja.in/settle-abroad/">
                                                <li>Permanent Residency</li>
                                            </a>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </nav>
                    </aside>
                )}
            </header>
        </>
    );
};

export default Header;
